<template>
  <v-dialog v-model="dialog" @input="v => v || closeDialog()" max-width="500px">
    <v-card>
      <v-card-title>
        <h2 v-if="messageTitle" class="md-title">
          {{ messageTitle | translate }}
        </h2>
      </v-card-title>
      <v-card-text class="py-4">
        <v-layout row wrap align-center justify-center>
          <v-flex xs8 md8 align-content-center>
            <span class="subheading title-boil">{{ "lng_billing_email_prompt" | translate }}</span>
            <v-text-field
              class="mt-0"
              v-model="email"
              required
            ></v-text-field>

            <v-checkbox v-model="terms" color="rgba(84,110,122,0.87)">
              <template v-slot:label>
                <div>
                  {{ "lng_billing_terms" | translate }}
                  <a @click="termsModalgtoggle=true">{{ "lng_register_terms_1" | translate }}</a>
                </div>
              </template>
            </v-checkbox>

          </v-flex>
        </v-layout>
      </v-card-text>
      <v-card-actions>
        <v-layout row wrap>
          <v-flex xs6 class="pr-2">
            <v-btn class="raised-btn" block flat @click="closeDialog">{{
              "lng_close" | translate
            }}</v-btn>
          </v-flex>
          <v-flex xs6 class="pl-2">
            <v-btn
              block flex xs12 flat
              :class="[ terms && /.+@.+/.test(email) ? 'primary-btn' : 'disabled-btn']"
              :disabled=" terms && /.+@.+/.test(email) ? false : true"
              @click="onSubmit"
              >{{ "lng_submit" | translate }}</v-btn
            >
          </v-flex>
        </v-layout>
      </v-card-actions>
    </v-card>
    <terms-modal
      :html-content="true"
      :help-text="termsAndCondText"
      :openDialog="termsModalgtoggle"
      :closeDialog="function(){termsModalgtoggle=false}"
    ></terms-modal>
  </v-dialog>
</template>

<script>
import { translate } from '../common/HelperFunctions';
import PdfDialog from "../components/PdfDialog.vue";

export default {
  name: "BeforePaymentEmail",
  components: {
    termsModal: PdfDialog,
  },
  data() {
    return {
      dialog: false,
      email: "",
      terms: false,
      emailRules: [v => !!v || "", v => /.+@.+/.test(v) || translate('lng_required_email')],
      termsModalgtoggle: false,
      termsAndCondText: "<p>Ved ibrugtagning af StokerCloud accepterer du følgende betingelser:</p><ol><li>Brug af StokerCloud er på eget ansvar. StokerCloud gør det muligt at justere parametre som har indvirkning på fyrets funktion. Sørg derfor <strong>ALTID</strong> at være i samme lokale som fyret, når der foretages justeringer. Foretag aldrig ændringer i et fyr, som ikke er under fysisk overvågning.</li><li>Vi understreger, at afstilling af alarm absolut ikke må udføres, medmindre man er helt klar over, hvorfor alarmen er tilstede, samt har mulighed for efterfølgende fysisk overvågning af fyret.</li><li>Stokersoft/NBE kan ikke holdes ansvarlig for evt. følgeeffekter af forkert satte værdier, som både er sat tilsigtet og utilsigtet, evt. som følge af fejl og andre forhold i StokerCloud softwaren.</li><li>Er man i tvivl om opsætning via StokerCloud, bør man benytte fyrets styrebox til justeringer og alene benytte StokerCloud til overvågning.</li><li>Der kan forekomme svigt på StokerCloud servicen. Disse vil forsøgt udbedret hurtigst muligt, men Stokersoft/NBE kan ikke holdes ansvarlig for tab som følge af manglende forbindelse, usendte SMS'er, emails mv.</li><li>Enhver form for hacking, herunder simpel tilegnelse af andre brugeres kodeord, medfører politianmeldelse og permanent udelukkelse fra servicen.</li><li>Det understreges igen - enhver ændring i fyrets parametre må kun foretages, såfremt man er tilstede ved fyret og kan tjekke resultatet heraf.</li></ol>"
    };
  },
  props: {
    userMenuData: {
      type: Object,
      default: () => {}
    },
    openDialog: {
      type: Boolean,
      default: false
    },
    closeDialog: {
      type: Function,
      default: undefined
    },
    saveSuccess: {
      type: Function,
      default: undefined
    },
    translate: {
      type: Boolean,
      default: true
    },
    messageTitle: {
      type: String,
      default: ""
    },
    OkButtonText: {
      type: String,
      default: "lng_ok"
    },
    htmlContent:{
      type: Boolean,
      default: false
    }
  },
  watch: {
    openDialog: function(newVal) {
      this.dialog = newVal;
    },
    userMenuData: function(newVal) {
      this.email = newVal['user.email'].val || '';
    }
  },
  methods: {
    onSubmit() {
      this.closeDialog()
      this.saveSuccess(this.email)
    }
  }
};
</script>
<style scoped>
.def-btn {
  color: rgb(84, 110, 122);
}
.md-title {
  font-size: 20px;
  font-weight: 500;
  letter-spacing: 0.005em;
}
</style>
